const ContactActionTypes = {};

ContactActionTypes.FETCH_ALL_CONTACT = 'FETCH_ALL_CONTACT';
ContactActionTypes.FETCH_CONTACT = 'FETCH_CONTACT';
ContactActionTypes.ADD_CONTACT = 'ADD_CONTACT';
ContactActionTypes.EDIT_CONTACT = 'EDIT_CONTACT';
ContactActionTypes.DELETE_CONTACT = 'DELETE_CONTACT';

export default ContactActionTypes;
